import React, { Component } from "react";

//import SimplifiedNavbar from "./SimplifiedNavbar";
import WebfineryNavbar from "./WebfineryNavbar";
import Footer from './footer/Footer.js';

import './SimplifiedLayout.css';

class SimplifiedLayout extends Component {
    render() {
        return (
            <div>
                <WebfineryNavbar fixed={this.props.fixedNavbar}/>
                <div className={this.props.fixedNavbar ? 'fixedNavbarCaseContainer' : null}>
                	{this.props.children}
                </div>
                <div className="FooterContainer">
                	<Footer className="footer-app"/>
                </div>
            </div>
        );
    }
}

export default SimplifiedLayout;



// WEBPACK FOOTER //
// ./src/SimplifiedLayout.js